import { styled } from 'libs/ui/styled';

export const CurrencyContainer = styled('div')<{ readOnly?: boolean }>(
  ({ readOnly }) => ({
    minWidth: readOnly ? 100 : 124,
  })
);
